import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'lib-config',
  templateUrl: './config.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatIconModule,
    MatDividerModule
  ],
  styleUrls: ['./config.component.scss']
})
export class ConfigComponent implements OnInit {
  groups = [
    {
      name: 'Compliance with KBFs',
      enabled: true,
      factors: [
        { name: 'TCO', enabled: true },
        { name: 'Affordability', enabled: true },
        { name: 'Availability', enabled: true },
        { name: 'Sustainability', enabled: true },
        { name: 'Productivity', enabled: true },
      ]
    },
    {
      name: 'Quality Cost',
      enabled: true,
      factors: [
        { name: 'Reactive Cost', enabled: true },
        { name: 'Warranty Cost', enabled: true },
        { name: 'Proactive Cost', enabled: true },
      ]
    },
    {
      name: 'Actual Revenue',
      enabled: true,
      factors: [
        { name: 'Actual Revenue', enabled: true },
      ]
    },
    {
      name: 'Actual Aftermarket Revenue',
      enabled: true,
      factors: [
        { name: 'Actual Aftermarket Revenue', enabled: true },
      ]
    },
    {
      name: 'Product Cost',
      enabled: true,
      factors: [
        { name: 'Cost $/HP', enabled: true }
      ]
    },
    {
      name: 'Lead Time',
      enabled: true,
      toggle: false,
      factors: []
    },
    {
      name: 'Stratergic Significance',
      enabled: true,
      toggle: false,
      factors: []
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<ConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const saved = localStorage.getItem('appConfig');

    if (saved) {
      const savedConfig = JSON.parse(saved);

      this.groups.forEach(group => {

        // If toggle is false, group MUST always be true
        if (group.toggle === false) {
          group.enabled = true;
          savedConfig[this.toKey(group.name)] = true;
        } else {
          // Normal case: load saved value
          const key = this.toKey(group.name);
          if (savedConfig[key] !== undefined) {
            group.enabled = savedConfig[key];
          }
        }

        // Load factor states
        group.factors = group.factors?.map(factor => {
          const key = this.toKey(factor.name);
          return {
            ...factor,
            enabled: savedConfig[key] !== undefined ? savedConfig[key] : factor.enabled
          };
        });

        this.updateGroupState(group);
      });
    }
  }



  /** Called when a group header toggle is changed */
  toggleGroup(group: any): void {
    if (group.toggle === false) {
      group.enabled = true;  // Always true
      return;
    }
    group.factors.forEach((factor: any) => (factor.enabled = group.enabled));
  }

  /** Called when any individual factor changes */
  updateGroupState(group: any): void {
    // If toggle is false or no factors exist, keep enabled TRUE
    if (group.toggle === false || group.factors.length === 0) {
      group.enabled = true;
      return;
    }

    const allDisabled = group.factors.every((f: any) => !f.enabled);
    group.enabled = !allDisabled;
  }


  save() {
    const config: Record<string, boolean> = {};
    this.groups.forEach(group => {
      group.factors?.forEach(factor => {
        const key = this.toKey(factor.name);
        config[key] = factor.enabled;
      });
    });
    localStorage.setItem('appConfig', JSON.stringify(config));
    this.dialogRef.close(true);
  }

  reset() {
    this.groups.forEach(group => {
      group.enabled = true;
      group.factors?.forEach(f => (f.enabled = true));
    });
  }

  closeIconClick() {
    this.dialogRef.close(false);
  }

  private toKey(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '_');
  }
}
